// Date and time helper functions

// Human representation of a period with month granularity
export function showDatePeriodMonth(start, end) {
  // dates not set
  if (!start) return null;
  // only start date
  const start_date = new Date(start);
  const start_month = start_date.toLocaleDateString('en', { month: 'long' });
  const start_year = start_date.getFullYear();
  if (!end) {
    return `${start_month} ${start_year}`;
  }
  // start and end date in same year
  const end_date = new Date(end);
  const end_month = end_date.toLocaleDateString('en', { month: 'long' });
  if (start_date.getFullYear() == end_date.getFullYear()) {
    return `${start_month} - ${end_month} ${start_year}`;
  }
  // start and end date in different years
  const end_year = end_date.getFullYear();
  return `${start_month} ${start_year} - ${end_month} ${end_year}`;
}

// Human representation of a period with day granularity
export function showDatePeriodDay(start, end) {
  // dates not set
  if (!start) return null;
  // only start date
  const start_date = new Date(start);
  const start_day = start_date.getDate();
  const start_month = start_date.toLocaleDateString('en', { month: 'long' });
  const start_year = start_date.getFullYear();
  if (!end) {
    return `${start_day} ${start_month} ${start_year}`;
  }
  // start and end date in same month
  const end_date = new Date(end);
  const end_day = end_date.getDate();
  const end_month = end_date.toLocaleDateString('en', { month: 'long' });
  const end_year = end_date.getFullYear();
  if (start_year == end_year && start_month == end_month) {
    return `${start_day} to ${end_day} ${start_month} ${start_year}`;
  }
  // start and end date in same year
  if (start_year == end_year) {
    return `${start_day} ${start_month} to ${end_day} ${end_month} ${start_year}`;
  }
  // start and end date in different years
  return `${start_day} ${start_month} ${start_year} to ${end_day} ${end_month} ${end_year}`;
}
